import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';

/** A plain horizontal divider line. */
export const Separator = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-px bg-border w-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};